export function getHumanDate(date) {
    date = new Date(date * 1000)
    return (date.getDate()) + ". " + MonthList[date.getMonth()] + " 2022"
    // -> Wed Jun 09 2010 14:12:01 GMT+0100 (BST)
}
export const MonthList = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']